module.exports = __webpack_public_path__ + "img/bnk1.805237b2.svg";